import { LanguageSchema } from "@/assets/lang";

const ro: LanguageSchema = {
  "title": "Caracatiță",
  "button": {
    "cancel": "Anulează",
    "ok": "OK",
    "discardChanges": "Respingeți modificările",
    "search": "Răsfoiește",
    "confirm": "Confirmați",
    "choose": "Selectați",
    "forward": "Următorul",
    "back": "Înapoi",
    "reset": "Înapoi",
    "apply": "Aplică",
    "login": "Autentificare",
    "logout": "Ieșiți",
    "send": "Trimiteți",
    "backToStart": "Înapoi la început",
    "backToLogin": "Înapoi la autentificare",
    "no": "Nu există",
    "yes": "Da",
    "toPayment": "Pentru plată",
    "finishOrder": "Plasați comanda",
    "thank": "Vă mulțumim",
    "sendInvite": "Trimiteți invitația",
    "resend": "Trimiteți din nou",
    "startNow": "Începeți acum",
    "skip": "Treci peste",
    "register": "Înregistrează-te acum",
    "registerNoCode": "Înregistrare fără cod",
    "save": "Economisiți",
    "saveChanges": "Aplicați modificările",
    "delete": "{target} delete",
    "addCart": "Adaugă lista în coșul de cumpărături",
    "orderNow": "Comandați acum",
    "add": "Adăugați la",
    "changePassword": "Schimbă parola",
    "changeLogin": "Modificați detaliile de conectare",
    "changeEmail": "Schimbați e-mailul",
    "edit": "Editați",
    "share": "Share",
    "delivererNotFound": "Furnizorul nu a fost găsit?",
    "joinLocation": "Alăturați-vă echipei",
    "createLocation": "Creați o locație",
    "editSupplier": "Furnizor @.lower:button.edit",
    "create": "Creați",
    "deleteSupplier": "Șterge furnizorul",
    "forwardApp": "Mergeți la aplicație",
    "endIntro": "Finalizați introducerea",
    "upload": "Încărcați",
    "showMore": "arată mai mult",
    "hide": "ascundeți",
    "deleteAll": "Ștergeți toate",
    "settings": "Setări",
    "manualSort": "Editare sortare manuală",
    "switchOldVersion": "La versiunea veche",
    "goToAppVersion": "Utilizați Octopus în browser",
    "updateList": "Adăugați la listă",
    "updateCart": "Adaugă în coș",
    "openCameraScanner": "Scaner cu cameră deschisă",
    "orderOverview": "La prezentarea generală a comenzilor",
    "deleteSupplierCart": "Ștergeți coșul de cumpărături",
    "resetAmount": "Resetarea cantităților de produse",
    "requestAiCall": "Solicitare apel AI",
    "filter": {
      "all": "Totul",
      "promotion": "Acțiuni",
      "productSuggestion": "Inspirații"
    }
  },
  "input": {
    "text": "Text",
    "password": "Parolă | Parole",
    "email": "Email",
    "number": "Număr",
    "url": "Link",
    "tel": "Telefon",
    "search": "Căutare",
    "date": "Data",
    "orderDate": "Data comenzii",
    "datetime": "Data",
    "datetime-local": "Ora ora locală",
    "month": "Luna",
    "week": "Săptămâna",
    "time": "Timp",
    "range": "Scară",
    "color": "Culoare"
  },
  "table": {
    "empty": "Tabelul nu selectează elemente"
  },
  "label": {
    "confirm": "confirmă",
    "pwConfirm": "@:input.password @:label.confirm",
    "newReminder": "Adăugați o nouă alarmă de comandă",
    "selectPlaceholder": "Vă rugăm să selectați",
    "orderHint": "Notă din partea furnizorului",
    "selectTitle": "Selectați",
    "date": "@:input.date",
    "time": "Ora",
    "dateTime": "@:label.date și @:label.time",
    "sum": "Total",
    "orderDetails": "Detalii despre factură",
    "promoCode": "Cod cupon",
    "orderNumber": "Numărul de comandă",
    "octopusId": "ID-ul caracatiței",
    "orderMessage": "Mesaj de comandă",
    "description": "Descriere",
    "sort": "Sortare",
    "priceRange": "Gama de prețuri",
    "login": "Vă rugăm să vă conectați",
    "user": "Utilizator",
    "newEmail": "E-mail nou",
    "oldPassword": "Vechiul @:input.password",
    "password": "@:input.password",
    "pwForget": "@:input.password uitat",
    "contactData": "Detalii de contact",
    "name": "Nume",
    "list": "Lista",
    "type": "Tip",
    "zip": "COD POȘTAL",
    "city": "Oraș",
    "street": "Adresa",
    "streetNumber": "Numărul casei",
    "phone": "Telefon",
    "fax": "Fax",
    "streetName": "Numele străzii",
    "postalCode": "@:label.zip",
    "deliverer": "@:object.deliverer",
    "customerNumber": "Numărul de client/numărul locului de achiziție",
    "quickstart": "Cod de pornire rapidă",
    "email": "@:input.email",
    "firstName": "Prenume",
    "lastName": "Nume",
    "dark": "Întuneric",
    "light": "Lumina",
    "standard": "Setarea sistemului",
    "amount": "Cantitate",
    "multipleAmount": "cantitatea trebuie să fie un multiplu de {target}",
    "maxAmount": "Numărul maxim de articole {target}",
    "standardList": "Lista standard",
    "language": "Limba",
    "aiCallLanguage": "Limba de apel",
    "oldMessages": "Știri mai vechi",
    "notification": {
      "allow": "Mesaje permise"
    },
    "permission": {
      "order": "@:object.order",
      "promotion": "@:object.promotion",
      "message": "@:object.message",
      "news": "Știri",
      "reminder": "Reamintire de comandă",
      "productPromotion": "Sugestii de produse",
      "sub": {
        "newOrder": "Comenzi noi",
        "updateStatus": "Actualizarea comenzilor",
        "added": "Promoție nouă",
        "ending": "Promoție la",
        "general": "Generalități"
      },
      "mode": {
        "push": "Mesaj Push",
        "email": "Notificare prin e-mail",
        "popup": "Popup"
      }
    },
    "teamRole": {
      "admin": "Admin",
      "user": "Membru al echipei Pro",
      "device": "Membru al echipei de bază",
      "OWNER": "Proprietar"
    },
    "teamRoleShort": {
      "admin": "Administrator",
      "user": "Pro",
      "device": "Baza",
      "OWNER": "Proprietar"
    },
    "support": {
      "general": "Suport Octopus",
      "gastro": "Echipa Serviciul Clienți Gastro",
      "technical": "Echipa Serviciu tehnic pentru clienți",
      "technicalLead": "Lider tehnic",
      "distribution": "Semnatar autorizat, marketing, vânzări",
      "service": "Echipa Serviciului Clienți"
    },
    "loading": {
      "location": "Încărcare @:object.location"
    },
    "onAccount": "Factura",
    "onAccountOrCash": "Factură sau numerar",
    "ON_ACCOUNT": "@:label.onAccount",
    "UNSPECIFIED": "nespecificat",
    "CASH": "@:label.cash",
    "cash": "Bar",
    "bar": "Bar / pub",
    "office": "Birou",
    "coffeeShop": "Cafenea / Bistro",
    "caterer": "Catering / cantină / cluburi",
    "club": "Club / discotecă",
    "EVENT": "Eveniment",
    "DEALER": "Comerciant",
    "takeAway": "Snack bar / Kiosk / Take-Away",
    "canteen": "Cantină",
    "restaurant": "Restaurant",
    "hotel": "Hotel",
    "spaetshop": "Benzinărie / magazin de noapte",
    "getraenkehaendler": "Retailer de băuturi",
    "getraenkeabholmarkt": "Piața de colectare a băuturilor",
    "STAR_GASTRONOMY": "Star gastronomie",
    "SYSTEM_GASTRONOMY": "Sistem de catering",
    "spaetShop": "Magazin târziu",
    "impress": "Imprimare",
    "termsOfUse": "Termeni de utilizare",
    "agreeAGB1": "Sunt de acord cu",
    "agreeAGB2": "Politica de confidențialitate",
    "agreeAGB3": "la",
    "category": "Categorie",
    "noCategory": "Fără categorie",
    "editTags": "Creați propriile categorii",
    "selectDeliverer": "Selectați @:object.deliverer",
    "threeChars": "Introduceți cel puțin trei caractere pentru a obține rezultatele căutării",
    "offlineMode": "Modul offline",
    "disable": "dezactivați",
    "enable": "activați",
    "at": "la",
    "atTime": "la",
    "and": "și",
    "customerNo": "Numărul de client",
    "current": "Curent",
    "tags": "Filtrează categoriile",
    "ownCategories": "Categorii proprii",
    "supplierCategories": "Categorii de furnizori",
    "noFilter": "Fără filtru",
    "quantity": "Cantitate",
    "quantityBiggerZero": "Cu cantitate",
    "or": "sau",
    "delivererType": {
      "online": "Online",
      "offline": "Offline"
    },
    "deleted": "Șters",
    "resetAmount": "Resetarea cantității produsului după comandă",
    "compatibilityMode": "Modul de compatibilitate",
    "timeIssueDelivery": "Data de livrare pe care ați specificat-o este trecută. Vă rugăm să alegeți o dată ulterioară.",
    "timeIssuePickup": "Ora de colectare pe care ați introdus-o este în trecut. Vă rugăm să alegeți o dată ulterioară.",
    "wait": "Vă rugăm să așteptați",
    "day": "Etichetă",
    "month": "Luna",
    "all": "Toate",
    "articleNo": "Articolul nr.",
    "targetStock": "Cantitate țintă",
    "targetStockShort": "Cantitate țintă",
    "resetProductQuantity": "Prin activarea cursorului, cantitatea de produse este resetată la zero după transmiterea cu succes a comenzii dumneavoastră. Dacă nu îl activați, cantitatea de produse rămâne precompletată pentru următoarea procesare a listei dumneavoastră.",
    "offlineMode1": "Modul offline vă oferă posibilitatea de a vă sincroniza lista și de a o gestiona fără o conexiune la internet.",
    "offlineMode2": "Când ieșiți din modul offline, toate modificările sunt sincronizate cu serverul.",
    "darkMode": "Modul întunecat",
    "compatibilityText": {
      "activate": "Activați acest mod dacă doriți să modificați cantitățile de produse din lista dvs. în aplicație, dar să plasați comanda prin intermediul portalului web.",
      "webPortal": "Atâta timp cât acest mod este activat, cantitatea din listă este sincronizată cu portalul web și nu este posibilă comandarea acestei liste prin intermediul aplicației.",
      "deactivate": "Dezactivați acest mod dacă doriți să comandați prin intermediul aplicației."
    },
    "newProductSuggestion": "Propunere de produs nou",
    "files": "Fișiere",
    "issue": "Problema",
    "place": "Locație",
    "expectation": "Așteptare",
    "steps": "Pași",
    "availability": "Disponibilitate",
    "availableFrom": "Disponibil la",
    "deletedLocations": "Locații șterse",
    "reducedListDesign": "Proiectarea listei reduse",
    "reducedListDesignDescription": "Designul redus al listei modifică vizualizarea listei dumneavoastră. Imaginile produselor sunt ascunse, dar sunt afișate butoane suplimentare pentru operare.",
    "insert": "Inserție",
    "camera": "Scaner de cameră",
    "scanner": "Scanner",
    "picture": {
      "takePicture": "Faceți o fotografie",
      "selectPicture": "Selectați fotografia",
      "editPicture": "Editați imaginea",
      "removePicture": "Eliminați imaginea"
    },
    "uncategorized": "Fără categorie",
    "orderDataLoading": "Se încarcă datele comenzii.",
    "screenshot": "Captură de ecran",
    "uploadImage": "Încărcați imaginea",
    "aiCallbackPhone": "Stocați numărul de telefon pentru rechemare"
  },
  "error": {
    "addReminder": "Alarma de comandă nu a putut fi atribuită unei liste",
    "noMatch": "{target} nu se potrivește",
    "notFound": "{target} nu a fost găsit. | {target} nu a fost găsit.",
    "invalid": "{target} nu este corect. | {target} nu sunt corecte.",
    "empty": "{target} este gol. | {target} sunt goale.",
    "noAuth": "{target} nu are permisiune. | {target} nu au permisiune.",
    "noAdmin": "Nu s-a găsit nicio permisiune de administrare.",
    "addCart": "Produsul nu a putut fi adăugat în coșul de cumpărături. | produsul nu a putut fi adăugat în coșul de cumpărături.",
    "addPromoPackage": "Pachetul promoțional nu a fost adăugat la coșul de cumpărături sau a fost adăugat doar parțial.",
    "addList": "Produsul nu a putut fi adăugat în listă. | Produsele nu au putut fi adăugate în listă.",
    "create": "{target} nu a putut fi creat. | {target} nu a putut fi creat.",
    "order": "Comanda nu a putut fi procesată.",
    "save": "{target} nu a putut fi salvată.",
    "delete": "{target} nu a putut fi șters.",
    "deleteUser": "Utilizatorul nu a putut fi șters.",
    "resendMail": "E-mailul nu a putut fi retrimis.",
    "sendLink": "Link-ul nu a putut fi trimis.",
    "removeProduct": "Produsul nu a putut fi scos din coșul de cumpărături. | Produsul nu a putut fi scos din coșul de cumpărături.",
    "registerFalse": "Înregistrarea a eșuat.",
    "loginFalse": "Autentificarea a eșuat.",
    "locationFalse": "Crearea locației a eșuat.",
    "orderFinish": "Comanda nu a putut fi creată.",
    "send": "{target} nu a putut fi trimis.",
    "loadSupplier": "Furnizorul nu a putut fi încărcat | Furnizorii nu au putut fi încărcați.",
    "loadLists": "Listele nu au putut fi încărcate.",
    "load": "{target} nu a putut fi încărcat. | {target} nu a putut fi încărcat.",
    "sendTicket": "Feedback-ul nu a putut fi trimis.",
    "scanBarcode": "Codul de bare scanat nu este valid.",
    "promotionLimitReached": "Max. Cantitatea de acțiune atinsă",
    "aiCall": "@:error.returnType.Necunoscut",
    "ajv": {
      "required": "Câmpurile obligatorii nu sunt completate",
      "format": "Introducerea nu a fost corectă: Introducerea trebuie să fie în formatul {formatInfo}.",
      "formatInfo": {
        "date": "Data",
        "time": "Ora",
        "email": "Email",
        "date-time": "Data & Ora"
      },
      "oneOf": "Datele introduse nu corespund niciuneia dintre valorile posibile",
      "minimum": "Intrarea se situează sub minimul de {min}",
      "maximum": "Intrarea depășește valoarea maximă a {max}",
      "enum": "Intrarea nu conține una dintre valorile posibile"
    },
    "returnType": {
      "Unknown": "A apărut o eroare",
      "BadRequest": "Cererea conține date incorecte",
      "NotFound": "Cererea nu a găsit un element.",
      "Unauthorized": "Autorizare lipsă",
      "Forbidden": "Solicitarea nu este permisă",
      "NotImplemented": "Cererea nu este implementată",
      "InvalidLogin": "Autentificare invalidă",
      "InvalidSession": "Sesiune invalidă",
      "InvalidPassword": "Parolă invalidă",
      "UserNotFound": "Utilizator neidentificat",
      "UserAlreadyExists": "Utilizatorul există deja",
      "UserEmailAlreadyExists": "Un utilizator cu acest e-mail există deja",
      "LocationNotFound": "Locația nu a fost găsită",
      "CartItemNotFound": "Produsul nu a fost găsit",
      "ItemAlreadyInCart": "Produsul se află deja în coșul de cumpărături, editați selecția în coșul de cumpărături",
      "ListAlreadyInCart": "Lista este deja în coșul de cumpărături, editați selecția în coșul de cumpărături. Lista poate fi editată numai după ce lista a fost comandată în coșul de cumpărături.",
      "ListCantBeDeleted": "Lista nu poate fi ștearsă.",
      "ListEmpty": "Lista este goală. Verificați dacă cel puțin un produs are o cantitate mai mare de 0.",
      "SupplierNotFound": "Nu s-a găsit furnizorul",
      "SupplierItemNotFound": "Produsul furnizorului nu a fost găsit",
      "OrderNotFound": "Comanda nu a fost găsită",
      "ListNotFound": "Lista nu a fost găsită",
      "ListItemNotFound": "Lista de produse nu a fost găsită",
      "ItemAlreadyInList": "Produsul este deja în listă, editați selecția în listă",
      "ItemNotFromListSupplier": "Produsul nu este de la furnizorul din această listă",
      "NotificationNotFound": "Notificarea nu a fost găsită",
      "TagNotFound": "Categoria nu a fost găsită",
      "TagAlreadyExists": "Categoria există deja",
      "UserNotInTeam": "Acest utilizator nu face parte din echipă",
      "TokenInvalid": "Codul introdus nu este valid",
      "ReminderNotFound": "Amintirea comenzii nu a fost găsită",
      "OwnerCantBeEdited": "Proprietarul nu are voie să editeze",
      "PromoCodeInvalid": "Codul de cupon nu este valabil",
      "PromoCodeInvalidAlreadyExists": "Codul cuponului a fost deja folosit",
      "QuickStartCodeInvalid": "Codul Quickstart nu este valabil",
      "SupplierAlreadyExists": "Furnizorul există deja",
      "SupplierCustomerInvalid": "Furnizorul de locație nu este valid",
      "LocationAlreadyExists": "Locația există deja",
      "JavaApiInternalServerError": "A apărut o eroare",
      "NewsNotFound": "Mesajul nu a fost găsit",
      "OrderMessageTooLong": "Mesajul de comandă depășește lungimea maximă",
      "EmailInvalid": "Emailul nu este valid",
      "TokenInvalidAlreadyUsed": "Codul introdus a fost deja utilizat",
      "SupplierBlocked": "Furnizorul este blocat",
      "PromotionExpired": "Articole promoționale expirate"
    },
    "scannedProductNotAvailable": "Produsul scanat nu este disponibil în catalogul furnizorului dumneavoastră, prin urmare nu poate fi adăugat în lista de scanare.",
    "scannerNotAvailable": "Nu există niciun scaner conectat la dispozitivul dvs. Vă rugăm să vă conectați la un scaner sau să verificați conexiunea existentă"
  },
  "error.": "A apărut o eroare",
  "target": {
    "username": "Nume utilizator",
    "user": "Utilizator",
    "userAndPw": "@:target.username și @:input.password",
    "setting": "Setare | Setări",
    "profile": "Profil",
    "location": "Locație",
    "order": {
      "paypal": "PayPal"
    },
    "product": "Produs | Produse",
    "request": "Cerere",
    "list": "Lista",
    "required": "Câmp obligatoriu",
    "field": "Câmp | Câmpuri",
    "deliverer": "Furnizor | Furnizori",
    "tag": "Categorie | Categorii",
    "password": "Parolă",
    "permission": "Autorizare | Permisiuni"
  },
  "messages": {
    "orderFrom": "Comandă de la",
    "mobileWeb": "Am observat că încercați să deschideți versiunea web a comenzii Octopus Order de pe un dispozitiv mobil. Pentru o experiență de utilizare mai bună, vă recomandăm să descărcați aplicația mobilă din magazinul de aplicații pentru dispozitive mobile și să o utilizați în locul versiunii web.",
    "mobileWeb2": "Următoarele linkuri vă vor duce la aplicația mobilă Octopus Order:",
    "setting": {
      "location": "Editați locația dvs.",
      "profile": "Editați-vă profilul de utilizator",
      "delivererAssign": "Atribuiți un furnizor locației dvs.",
      "delivererSelect": "Selectați un furnizor",
      "inputCustomerNr": "Introduceți numărul de client",
      "changeLocation": "Schimbați locația",
      "welcome1": "Bună ziua {name}",
      "welcome2": "Aici puteți alege",
      "welcome3": "ce reprezentare preferați"
    },
    "emptyCart": "Ne pare rău, coșul dumneavoastră de cumpărături este gol.",
    "emptySuggestion": "Ne pare rău, nu avem nicio sugestie de produs pentru dvs. în acest moment.",
    "card": {
      "forwardPoints": "Faceți clic aici pentru a fi redirecționat către @:object.pointSystem",
      "points": "Puncte Octopus",
      "shop": "Către magazinul Octopus",
      "currentPromotion": "Acțiuni curente",
      "createLocationExplanation": "O locație poate fi un bar, un restaurant, un hotel, un birou sau o afacere similară.",
      "productSuggestion": "Noutăți și sugestii privind produsele"
    },
    "noPromotion": "Ne pare rău, nu avem nicio promoție pentru dvs. în acest moment.",
    "promotion": {
      "order": "Se poate comanda la",
      "octopus": "Promoții Octopus",
      "deliverer": "Promoții de la furnizorii dumneavoastră",
      "articles": "Aceste articole au un preț special în acest moment"
    },
    "home": {
      "createLocation": "Nou @:messages.location.create",
      "welcome1": "Bună ziua {name}",
      "welcome2": "ce locație doriți?",
      "image1": "Amestecat, turnat, comandat!",
      "image2": "Securizat, digital, comandă!",
      "image3": "Simplu, rapid, livrați!"
    },
    "dashboard": {
      "catalog": {
        "availableProduct": "Toate articolele disponibile",
        "delivererCatalog": "Sortimentul furnizorului",
        "createProduct": "Adăugați un produs",
        "createdCustomProduct": "Produsul a fost adăugat la listă.",
        "noReducedSupplier": "În prezent, niciunul dintre furnizorii dumneavoastră nu oferă oferte."
      },
      "home": {
        "orders": "Ultimele dvs. comenzi",
        "favouriteList": "Ultimele dumneavoastră liste comandate",
        "news": "Știri Octopus"
      },
      "list": {
        "allLists": "Toate listele din această locație",
        "createList": "Nou @:titleRoute.addList",
        "noSupplier": "Nu ați adăugat încă un furnizor la locația dvs. Vă rugăm să adăugați un furnizor prin intermediul setărilor."
      },
      "message": {
        "available": "Știri disponibile"
      },
      "setting": {
        "order": "Totul despre comenzile dvs. dintr-o singură privire",
        "team": "Privire de ansamblu și gestionare a echipei dvs.",
        "deliverer": "Aici puteți vedea furnizorii dvs.",
        "notification": "Gestionați aici notificările dvs.",
        "display": "Alegeți între modul întunecat sau luminos",
        "statistic": "Aici puteți vizualiza evaluările dvs.",
        "imprint": "Informații și aspecte legale",
        "support": "Contactați Octopus Order",
        "orderNotificationTimer": "Setați alarma de comandă",
        "intro": "Descoperiți toate funcțiile aplicației"
      }
    },
    "location": {
      "thank": "@:button.thank",
      "sendMsg": "Trimiteți un mesaj",
      "create": "Adăugați locația",
      "requestSent": "Cererea dumneavoastră către furnizorul {deliverer} este în curs de examinare. Un reprezentant vă va contacta în zilele următoare.",
      "assignDeliverer": "Atribuiți un furnizor pentru locația dvs.",
      "welcome1": "Bună ziua {name}",
      "intro": "În 4 pași scurți completăm împreună profilul dvs."
    },
    "noOrders": "Nu ați plasat încă nicio comandă.",
    "noOrdersFilter": "Nu ați plasat nicio comandă în acest interval de timp.",
    "noLists": "Nu ați creat încă nicio listă.",
    "noNotifications": "Nu ați primit încă nicio notificare.",
    "noNews": "Ne pare rău, momentan nu sunt disponibile știri despre Octopus.",
    "order": {
      "deliveryType": "Selectați metoda de livrare",
      "deliveryTime": "Selectați ziua livrării",
      "pickupTime": "Selectați ora de preluare",
      "pickup": "Ridicați",
      "delivery": "Livrare",
      "overview": "Prezentare generală a comenzilor",
      "choosePayment": "Selectați metoda de plată",
      "redirectPayment": "În pasul următor veți fi redirecționat către {target}.",
      "rememberPayment": "Utilizați metoda de plată pentru comenzi viitoare.",
      "voucher": "Voucher | Vouchere",
      "redeemVoucher": "@:messages.order.voucher redeem",
      "voucherCode": "Introduceți codul voucherului",
      "currentOrders": "Comenzile mele",
      "orderProducts": "Comanda dvs. @:obiect.articol",
      "otherProducts": "Alte articole comandate frecvent",
      "sent": "Comanda dvs. a fost transmisă cu succes către {target}.",
      "locationIssue": "Locația de preluare lipsă. Vă rugăm să introduceți o locație de preluare."
    },
    "deliverer": {
      "allDeliverers": "Toate @:object.deliverer din {location}",
      "addDeliverer": "Adăugați un @:object.deliverer",
      "noEmail": "Vă rugăm să adăugați o adresă de e-mail la expeditor înainte de a putea comanda"
    },
    "team": {
      "invite": {
        "welcome1": "@:messages.home.welcome1",
        "welcome2": "Invitați alți angajați sau parteneri la aplicația...",
        "copy": "Sau pur și simplu copiați codul și partajați-l:",
        "messenger": "Invitați direct prin intermediul mesagerului ales de dvs:",
        "mail": "Prin adresa de e-mail",
        "joinTeam": "Alăturați-vă echipei noastre",
        "joinTeam2": "Ați fost invitat la locația {location} în aplicația Octopus Order!\n\nCu acest link vă puteți alătura direct echipei dvs.\n\n{inviteLink}\n\nDacă acest link nu funcționează, vă puteți înscrie în echipă în aplicație cu codul\n\n{link}\n\npentru a vă alătura noii echipe.\n\nPentru Android: {appLinkAndroid}\n\nPentru IOS: {appLinkIOS}",
        "shareHint": "Din motive de securitate, codul generat/trimis poate invita doar utilizatorii de bază. Pentru o invitație cu drepturile selectate, vă rugăm să utilizați invitația prin e-mail."
      },
      "management": {
        "members": "Membrii echipei din {location}",
        "inviteMember": "Invitați membrii echipei",
        "addDevice": "Adăugați dispozitiv",
        "permissionExplanation": "Prezentare generală a drepturilor rolurilor noastre:"
      }
    },
    "missingPermission": "Permisiune lipsă: {permission}",
    "missingCartOrderPermission": "Permisiunile dvs. din aplicație nu sunt suficiente. Vă rugăm să contactați proprietarul locației dvs. pentru a finaliza o comandă.",
    "permission": {
      "all": "Toate permisiunile",
      "locationOrderHistoryRead": "Citirea istoricului comenzilor",
      "locationListRead": "Vizualizare liste",
      "locationListItemRead": "Vizualizați lista de produse",
      "locationListItemCreate": "Crearea de liste de produse",
      "locationListItemUpdate": "Editarea listei de produse",
      "locationListItemDelete": "Ștergeți lista de produse",
      "locationListCreate": "Creați liste",
      "locationListUpdate": "Editarea listelor",
      "locationListDelete": "Ștergerea listelor",
      "locationCartRead": "Vezi coșul de cumpărături",
      "locationCartAdd": "Umpleți coșul de cumpărături",
      "locationCartUpdate": "Editarea produselor din coșul de cumpărături",
      "locationCartDelete": "Ștergeți produsele din coșul de cumpărături",
      "locationOrderCreate": "Creați comanda",
      "locationOrderRequest": "Executarea cererii de comandă",
      "locationRead": "Vizualizare locație",
      "locationCreate": "Crearea locației",
      "locationUpdate": "Editați locația",
      "locationDelete": "Șterge locația",
      "locationTeamRead": "Vezi echipa",
      "locationTeamMemberAdd": "Adăugați un membru al echipei",
      "locationTeamMemberDelete": "Șterge un membru al echipei",
      "locationTeamMemberRoleUpdate": "Editați rolurile membrilor echipei",
      "locationSupplierRead": "Vezi furnizorii",
      "locationSupplierCreate": "Adăugați furnizori",
      "meRead": "Citiți propriile date de utilizator",
      "meUpdate": "Editarea datelor proprii de utilizator",
      "meDelete": "Ștergeți propriul utilizator",
      "locationListReminderCreate": "Crearea alarmei de comandă",
      "locationListReminderDelete": "Ștergeți alarma de comandă",
      "locationListReminderRead": "Vizualizați alarma de comandă",
      "locationListReminderUpdate": "Editați alarma de comandă",
      "locationContactSupplier": "Contactați furnizorul"
    },
    "noListEntries": "În prezent nu există articole în această listă",
    "noSearchResults": "Nu s-au găsit articole pentru filtrul dvs.",
    "noEntries": "Nu există articole disponibile",
    "noMail": "Nu s-a primit nicio corespondență",
    "login": {
      "emailSent": "Tocmai v-am trimis un e-mail",
      "setPassword": "Puteți seta o nouă parolă prin intermediul linkului",
      "resetPassword": "Introduceți adresa dvs. de e-mail și primiți o nouă parolă"
    },
    "start": {
      "notNew": "Sunteți deja client",
      "new": "Prima dată aici"
    },
    "cart": {
      "amount": "{amount} Poziții ale articolului",
      "selectionFrom": "Selecție la {deliverer}",
      "fromList": "Din listele dumneavoastră",
      "noList": "Fără listă",
      "lastOrder": "De la ultima dvs. comandă",
      "amountItems": "{amount} Articol unic",
      "upgradeToPromotion": "Aproape gata! Doar {amount} Piese până la {shortTitle} Acțiune 🏷️ → comandă acum",
      "convertToPromotion": "Acțiune securizată 🏷️ → activați acum"
    },
    "register": {
      "intro": "Pentru a vă crea profilul avem nevoie de câteva informații",
      "thank": "Vă mulțumim {name}",
      "emailSent": "@:messages.login.emailSent",
      "validate": "Vă rugăm să confirmați contul dvs. prin intermediul linkului",
      "validateEmail": "@:{'messages.register.validate'} trimis la adresa dvs. de e-mail înainte de a putea comanda",
      "noCode": "Nu am un cod de invitație",
      "code": "Am primit un cod de invitație",
      "skipEmail": "Din păcate, nu am găsit adresa de e-mail pe care ați introdus-o. Vă rugăm să confirmați din nou adresa dvs. de e-mail."
    },
    "didYouMean": "Căutați cumva {target}?",
    "didYouCheck": "Ați căutat toți furnizorii în vizualizarea anterioară?",
    "agbRequired": "Trebuie să fiți de acord cu politica de confidențialitate.",
    "list": {
      "repeatEach1": "Memento",
      "repeatEach2": "Toate",
      "noTags": "Nu sunt disponibile categorii de filtre. Adăugați categorii la lista de produse.",
      "overrideCartList": "Lista se află deja în coșul de cumpărături. Doriți să suprascrieți coșul de cumpărături?",
      "overrideProductList": "Acest produs se află deja în coșul de cumpărături. Doriți să vă suprascrieți coșul de cumpărături?",
      "noReminder": "Nu au fost create încă alarme de comandă pentru această listă.",
      "amountReset": "Cantitățile de produse au fost resetate.",
      "resetCheck": "Sunteți sigur că doriți să resetați toate cantitățile din această listă la 0?"
    },
    "pressEnter": "Confirmați pe tastatură pentru a adăuga",
    "changedEmail": "Tocmai v-am trimis un e-mail la noua adresă. Pentru a aplica modificarea, vă rugăm să faceți clic pe link-ul trimis.",
    "updateLoading": "Actualizarea este în curs de instalare",
    "intro": {
      "home": {
        "msg1": "Faceți clic pe antet pentru a vă întoarce la prezentarea generală a locației și la coșul de cumpărături.",
        "title1": "Ajungeți la locațiile dvs. și la coșul de cumpărături",
        "msg2": "Cele mai recente comenzi ale dvs. și listele de comenzi frecvente pot fi accesate direct prin intermediul tabloului de bord.",
        "title2": "Privire de ansamblu asupra activităților dvs.",
        "msg3": "Utilizați bara de meniu pentru a ajunge la destinație cu un singur clic.",
        "title3": "Navigație accesibilă peste tot"
      },
      "list": {
        "title1": "Ordinea începe aici",
        "msg1": "Puteți accesa listele dvs. și catalogul prin intermediul antetului. Aici puteți căuta articolele furnizorilor dumneavoastră.",
        "title2": "Furnizorii dvs.",
        "msg2": "Aici puteți vizualiza și edita listele de comenzi ale furnizorilor dvs. sau puteți crea dvs. liste noi.",
        "title3": "Sortare și ștergere",
        "msg3": "Atinge imaginea produsului pentru a selecta unul sau mai multe articole, pentru a le muta prin glisare și fixare sau pentru a le șterge folosind pictograma coșului de gunoi.",
        "title4": "Personalizați cu ușurință lista",
        "msg4": "Cantitatea unui produs poate fi modificată folosind butoanele plus și minus. Glisați spre dreapta pentru a elimina produsul din listă.",
        "title5": "Găsiți rapid articole",
        "msg5": "În catalog puteți vizualiza și căuta articolele individuale ale furnizorilor dvs. și le puteți filtra în funcție de categorie."
      },
      "promotion": {
        "title1": "Promoții și sugestii",
        "msg1": "Aici puteți vedea promoțiile curente, sugestii de produse sau noutăți de la furnizorii dvs. sau de la Octopus Order.",
        "title2": "Oferte promoționale de la furnizorii dvs.",
        "msg2": "Aici puteți vedea articolele de la furnizorii dvs. pentru care sunt disponibile în prezent oferte speciale.",
        "title3": "Sugestii și știri actuale",
        "msg3": "Cu ajutorul sugestiilor de produse primiți informații despre cele mai recente tendințe din industria băuturilor. În secțiunea de știri puteți afla toate noutățile despre Octopus."
      },
      "setting": {
        "msg1": "Aici vă puteți gestiona furnizorii și locațiile, puteți face setări, vizualiza comenzile sau contacta asistența.",
        "title1": "Setări ale aplicației",
        "msg2": "Aici puteți seta alarme pentru a vă reaminti în mod regulat să vă comandați lista.",
        "title2": "Nu mai uitați niciodată o comandă",
        "msg3": "Aici puteți să vă gestionați echipa și să invitați alți membri ai echipei la Octopus Order.",
        "title3": "Propria dvs. echipă",
        "msg4": "Aici aveți o imagine de ansamblu a tuturor furnizorilor dvs. și puteți să îi editați sau să îi eliminați, precum și să adăugați furnizori noi.",
        "title4": "Prezentare generală a furnizorilor"
      }
    },
    "ordering": "Comanda este în curs de executare",
    "noConnection1": "Nu există conexiune la server",
    "noConnection2": "Vă rugăm să verificați conexiunea dvs. la internet",
    "switchLocation": "Notificarea aparține unei alte locații. Doriți să schimbați locația?",
    "containsExpiredPromotion": "Există un articol promoțional expirat în coșul dvs. de cumpărături. Vă rugăm să îl eliminați pentru a continua cu comanda.",
    "addProductsViaScanner": "Adăugați produse prin intermediul scanerului",
    "scanDesiredProducts": "Scanați produsele dorite",
    "scanToAddMoreProducts": "Scanați pentru a adăuga mai multe produse",
    "updateScanItems": "Doriți să adăugați produsele scanate la lista dumneavoastră? Numărul de articole din listă va fi suprascris.",
    "addScanItems": "Doriți să adăugați articolele scanate în coșul de cumpărături?",
    "holidayDeliveryTitle": "Ziua de livrare selectată este o zi de sărbătoare!",
    "holidayDelivery": "Vă rugăm să vă adresați furnizorului dvs. pentru data exactă de livrare.",
    "longOrder": "Comanda dvs. este mai mult de șapte zile în viitor. Chiar doriți să comandați la {date}?",
    "cartDataMissing": "Date de comandă incorecte",
    "newBinaryVersion": "O nouă versiune este disponibilă și conține modificări importante. Vă rugăm să vă actualizați versiunea.",
    "deliveryDayWarningTitle": "Data selectată nu este o zi obișnuită de livrare!",
    "deliveryDayWarning": "Vă rugăm să clarificați în prealabil cazurile excepționale cu furnizorul.",
    "holidayPickupTitle": "Ziua de colectare selectată este o sărbătoare legală!",
    "holidayPickup": "Vă rugăm să vă adresați furnizorului dvs. pentru data exactă de colectare.",
    "modal": {
      "updateLocationTypeTitle": "Alegerea ta, avantajul tău",
      "updateLocationTypeDescription": "Atunci când vă selectați activitatea de catering, vă personalizăm conținutul și promoțiile. Puteți modifica această setare în orice moment.",
      "updateLocationTypeHint": "Selecția este utilizată numai în cadrul aplicației și poate fi personalizată în orice moment."
    },
    "currentLocation": "Sunteți în prezent în locația"
  },
  "object": {
    "order": "Comandă | Comenzi",
    "article": "Pozițiile articolelor",
    "promotion": "Acțiune | Acțiuni",
    "location": "Locație",
    "cart": "Coș de cumpărături",
    "list": "Listă | Liste",
    "filter": "Filtru",
    "message": "Știri | Știri",
    "catalog": "Catalog",
    "notification": "Notificare | Notificări",
    "notificationOption": "@:object.notification{'soptions'}",
    "setting": "Setări",
    "intro": "Apptour",
    "home": "Acasă",
    "dark": "Întuneric",
    "light": "Lumina",
    "zip": "COD POȘTAL",
    "city": "Oraș",
    "street": "Strada",
    "lastname": "Nume",
    "firstname": "Prenume",
    "address": "Adresa",
    "zipCity": "@object:zip, @object:oraș",
    "profile": "Profil",
    "pointSystem": "Sistem de puncte",
    "amount": "Cantitate",
    "price": "Preț unitar",
    "total": "Preț total",
    "notAvailable": "Informația privind prețul nu este disponibilă",
    "sort": "Sortare",
    "alphabetic": "Alfabetic",
    "filterCategory": "@:object.filter{'category'}",
    "priceRange": "Gama de prețuri",
    "team": "Echipa",
    "deliverer": "Furnizor | Furnizori",
    "display": "Opțiuni de afișare",
    "statistic": "Statistici",
    "imprint": "Imprimare",
    "law": "Juridic",
    "support": "Suport pentru comenzi Octopus",
    "filterOption": {
      "spirits": "Băuturi spirtoase",
      "nonAlcoholic": "Băuturi nealcoolice",
      "beer": "Bere",
      "gastro": "Nevoi gastro",
      "wine": "Vin",
      "food": "Mâncare",
      "nonFood": "Non Food",
      "other": "Altele"
    },
    "suggestion": "Produs{sugestie} | Produs{sugestie}",
    "news": "Știri",
    "days": "Zile | Zi",
    "hours": "Ore | Ora",
    "minutes": "Minute | Minute",
    "validFor": "Valabil pentru {value}",
    "validUntil": "Valabil până la",
    "expired": "Expirat",
    "totalPosition": "Poziția totală",
    "totalOrder": "Valoarea totală a comenzii"
  },
  "enumT": {
    "pinned": "Fixat",
    "new": "Nou",
    "restocked": "Disponibil din nou",
    "reduced": "În ofertă",
    "notInStock": "Cu termen de livrare",
    "promotion": "Articole promoționale",
    "issueType": {
      "bug": "Bug",
      "feature": "Caracteristică"
    },
    "contactWay": {
      "none": "Vă rugăm să nu contactați",
      "email": "Email",
      "phone": "Telefon",
      "emailOrPhone": "Email sau telefon"
    },
    "sortDirection": {
      "asc": "Alfabetic crescător",
      "desc": "Alfabetic descrescător",
      "catFilter": "Prin categoria proprie",
      "catSupplier": "După categoria furnizorului",
      "manually": "Sortare manuală"
    },
    "weekday": {
      "mon": "Luni",
      "tue": "Marți",
      "wed": "Miercuri",
      "thu": "Joi",
      "fri": "Vineri",
      "sat": "Sâmbătă",
      "sun": "Duminică"
    },
    "repeatCycle": {
      "once": "unic",
      "week": "săptămânal",
      "month": "lunar",
      "appendix": {
        "week": "săptămână(e)",
        "month": "lună(e)"
      }
    },
    "month": {
      "january": "ianuarie",
      "february": "Februarie",
      "march": "Martie",
      "april": "Aprilie",
      "may": "Mai",
      "june": "Iunie",
      "july": "Iulie",
      "august": "August",
      "september": "Septembrie",
      "october": "Octombrie",
      "november": "Noiembrie",
      "december": "Decembrie"
    }
  },
  "modal": {
    "selection": "Alegeri",
    "addList": "Adăugați la listă",
    "addCart": "Adaugă în coșul de cumpărături",
    "openCatalog": "Deschideți în catalog"
  },
  "success": {
    "addReminder": "Comanda ceas deșteptător a fost adăugat",
    "editReminder": "Comandă alarmă salvată",
    "deleteReminder": "Alarma de comandă a fost ștearsă",
    "addCart": "Produsul a fost adăugat în coșul de cumpărături. | produsul a fost adăugat în coșul de cumpărături",
    "addPromoPackage": "Pachet promoțional a fost adăugat în coșul de cumpărături.",
    "addCartNumber": "{target} Un singur articol din pozițiile articolului {target2} a fost adăugat în coșul de cumpărături",
    "addList": "Produsul a fost adăugat în listă. | Produsele au fost adăugate în listă.",
    "order": "Lista a fost comandată.",
    "save": "{target} a fost salvat cu succes. | {target} au fost salvate cu succes.",
    "resendMail": "E-mailul a fost retrimis.",
    "copyLink": "Linkul a fost copiat",
    "sendLink": "Linkul a fost trimis.",
    "removeProduct": "Produsul a fost eliminat din coșul de cumpărături. | Produsul a fost scos din coșul de cumpărături.",
    "orderFinish": "Comanda a fost creată.",
    "delete": "{target} a fost șters.",
    "deleteUser": "Utilizatorul a fost șters",
    "deleteMulti": "{amount} {target} a fost șters.",
    "send": "{target} a fost trimis.",
    "create": "{target} a fost creat.",
    "edit": "{target} a fost editat cu succes.",
    "add": "{target} a fost adăugat.",
    "deleteTeam": "Utilizatorul a fost eliminat de către echipă.",
    "setRole": "Rolul utilizatorului a fost setat cu succes",
    "joinLocation": "Locația a fost adăugată cu succes",
    "sendInvite": "E-mailul de invitație a fost trimis.",
    "sendTicket": "Am primit feedback-ul dumneavoastră. Vă mulțumim foarte mult.",
    "aiCall": "Octobotul vă va suna în scurt timp."
  },
  "success.": "Campanie reușită",
  "alert": {
    "delete": {
      "account": "Dorești să ștergi definitiv contul tău și toate locațiile asociate?",
      "reminder": "Doriți cu adevărat să ștergeți această alarmă de comandă?",
      "location": "Chiar doriți să ștergeți această locație?",
      "list": "Doriți cu adevărat să ștergeți lista \"{target}\"?",
      "noList": "Doriți să eliminați toate produsele din coșul dumneavoastră de cumpărături?",
      "cartSupplier": "Doriți să vă goliți coșul de cumpărături la \"{target}\"?",
      "cartProduct": "Doriți cu adevărat să ștergeți produsul \"{target}\" din coșul de cumpărături?",
      "cartList": "Doriți cu adevărat să eliminați lista \"{target}\" și toate articolele aferente din coșul de cumpărături?",
      "product": "Doriți cu adevărat să ștergeți produsul \"{target}\" din listă? | Doriți cu adevărat să ștergeți produsele selectate din listă?",
      "supplier": "Doriți să eliminați {name} din lista furnizorilor? Atenție: Eliminarea unui furnizor elimină și toate listele pentru acest furnizor.",
      "member": "Doriți cu adevărat să eliminați {target}\" din echipă?",
      "tag": "Doriți cu adevărat să eliminați \"{target}\" din categoriile dumneavoastră?",
      "customSupplier": "Chiar doriți să ștergeți acest furnizor?",
      "scanProduct": "Doriți cu adevărat să eliminați produsul \"{target}\" din articolele dvs. scanate?"
    },
    "delivererSuccess": "Furnizorul a fost adăugat cu succes",
    "delivererError": "Eroare",
    "delivererSuccessMessage": "Am adăugat {target} la locația dumneavoastră.",
    "delivererErrorMessage": "{target} nu a putut fi adăugat la locația dvs. Vă rugăm să verificați datele pe care le-ați introdus.",
    "selectList": "Alegeți o listă",
    "selectSupplier": "Alegeți un furnizor",
    "noList": "Nu există nicio listă disponibilă pentru acest furnizor.",
    "noSupplier": "Niciun furnizor disponibil pentru acest articol",
    "discardFormTitle": "Atenție!",
    "noInternet": "Nu toate datele offline au putut fi sincronizate. Vă rugăm să verificați conexiunea dvs. la internet.",
    "compatibilityMode": "Ați activat modul de compatibilitate. Cât timp acesta este activ, puteți comanda numai prin intermediul portalului web. Cantitatea pe care ați specificat-o se află acum în coșul de cumpărături. Dacă doriți să comandați prin intermediul aplicației, dezactivați acest mod în setările listei.",
    "discardForm": "Datele dvs. nu vor fi salvate. Părăsiți pagina oricum?",
    "syncing": "Listele sunt sincronizate",
    "logout": "Chiar doriți să vă radiați?",
    "upgradeToPromotion": "Folosiți promoția acum? Cantitatea este ajustată automat la cantitatea minimă ({target})",
    "convertToPromotion1": "Aplicați acțiunea?",
    "convertToPromotion2": "{target1} Articol promoțional, {target2} obișnuit",
    "orderAmountOverLimit": "Limită atinsă: {isAmount} Articol promoțional în coșul de cumpărături. Max. +{availableAmount} posibil",
    "scannerNotActivated": "Funcția de scaner nu este susținută în prezent de furnizorii dumneavoastră!",
    "scannerAvailableOnlyInApp": "Funcția de scanare este disponibilă numai în aplicație!",
    "addLastOrderToCart": "Dorești să adaugi din nou în coș toate articolele și cantitățile din ultima ta comandă?"
  },
  "titleRoute": {
    "locationData": "Creați o locație",
    "locationCreate": "@:titleRoute.locationData",
    "locationDeliverer": "Selectați furnizorul",
    "locationAdd": "Adăugați locația",
    "locationJoin": "Alăturați-vă locației",
    "addLocationDeliverer": "Adaugă furnizor",
    "editLocationDeliverer": "Editare furnizor",
    "settingProfile": "Profil",
    "settingLocation": "Editează locația",
    "settingOrder": "Comandă | Comenzi",
    "settingOrderDetail": "Detalii comandă",
    "settingTeam": "Echipa",
    "settingTeamInvite": "Invitați echipa",
    "settingDeliverer": "Furnizori",
    "settingDelivererSelect": "Alegeți furnizorul",
    "settingNotification": "Notificări",
    "settingDisplay": "Opțiuni de afișare",
    "settingSupport": "Asistență",
    "settingLegal": "Legal",
    "cart": "Coș de cumpărături",
    "orders": "Comenzi",
    "filter": "Filtru",
    "addList": "Creați lista",
    "editList": "Editează lista",
    "notificationDetails": "@:titleRoute.settingNotification",
    "orderNotificationTimer": "Comandă alarma",
    "changePassword": "Schimbare parolă",
    "addProduct": "Adăugați un produs",
    "editProduct": "Editați produsul",
    "agb": "Politica de confidențialitate",
    "news": "Știri Octopus",
    "suggestion": "Propunere de produs",
    "productDetails": "Detalii despre produs",
    "promotionDetails": "Detalii despre acțiune",
    "productPresentation": "@:titleRoute.productDetails",
    "promotion": "@:titleRoute.promotionDetails",
    "settingIntro": "Apptour",
    "feedback": "Creați un feedback",
    "scanner": "Scanner",
    "skipEmail": "Verificare e-mail",
    "deleteLocations": "Locații șterse",
    "aiCall": "Comanda AI"
  },
  "placeholder": {
    "search": "Căutare",
    "selectSize": "Selectați dimensiunea",
    "selectVariant": "Selectați varianta",
    "location": {
      "name": "Numele locației dvs.",
      "type": "Tipul de locație",
      "zip": "Codul poștal",
      "ownZip": "Codul poștal al propriei locații",
      "city": "Oraș",
      "street": "Strada",
      "streetNumber": "Nu.",
      "phone": "Număr de telefon",
      "internationalPhone": "Numărul de telefon internațional",
      "deliverer": "@:select object.deliverer",
      "customerNumber": "@:label.customerNumber introduceți"
    },
    "email": "Email",
    "newEmail": "Noul e-mail",
    "oldPassword": "Vechiul @:input.password",
    "password": "@:input.password",
    "passwordRepeat": "@:input.password repeat",
    "sendMessageDeliverer": "Trimiteți un mesaj către {deliverer} ...",
    "inviteCode": "Introduceți codul de invitație",
    "firstName": "@:label.firstName",
    "lastName": "@:label.lastName",
    "name": "Nume",
    "phone": "@:placeholder.location.phone",
    "street": "Strada",
    "zip": "COD POȘTAL",
    "city": "Oraș",
    "alphabetic": "Alfabetic",
    "customerNumber": "Număr de client",
    "customerNumberPlus": "Numărul clientului/Numărul punctului de vânzare",
    "quickstart": "Cod de pornire rapidă",
    "paymentMethod": "Metoda de plată",
    "pickupMethod": "Locație",
    "deliveryDate": "Data livrării",
    "emailOrPhone": "@:placeholder.email",
    "code": "Codul invitației",
    "packaging": "Dimensiunea pachetului",
    "searchOrAdd": "Căutați sau adăugați o categorie",
    "tagName": "Numele categoriei",
    "pickupLocation": "Ridicați în",
    "pickupDate": "Ora de colectare",
    "quantity": "Cantitate",
    "eancode": "Cod EAN",
    "customSupplierType": "Tipul furnizorului",
    "issueType": "Tipul de feedback",
    "title": "Titlu",
    "bug": {
      "issue": "Care este problema?",
      "place": "Unde apare problema?",
      "expectation": "La ce comportament v-ați aștepta în locul comportamentului actual?",
      "steps": "Ce măsuri au fost luate până la apariția problemei? / Cum poate fi reprodusă această eroare?"
    },
    "feature": {
      "expectation": "Ce funcție suplimentară ați dori să vedeți?",
      "place": "Unde vă lipsește funcția dorită?"
    },
    "select": "Selectați",
    "contactWay": "Cum vă putem contacta pentru întrebări și actualizări?"
  },
  "option": {
    "industry": {
      "PRIVATE": "Privat",
      "GETRAENKEFACHGROSSHANDEL": "Băuturi cu ridicata",
      "LEBENSMITTEL_GROSSHANDEL": "Produse alimentare cu ridicata",
      "HANDELSWAREN_ALLGEMEIN": "Mărfuri generale",
      "SONSTIGE": "Altele"
    },
    "customSupplierType": {
      "meat": "Furnizor de carne",
      "vegetable": "Legume",
      "drinks": "Băuturi",
      "hygiene": "Articole de igienă",
      "other": "Altele"
    }
  }
}

export default ro;